import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M23.034 0H.966A.966.966 0 0 0 0 .966v22.068c0 .533.433.966.966.966h22.068a.966.966 0 0 0 .966-.966V.966A.966.966 0 0 0 23.034 0m-.967 22.067H1.933V1.933h20.134z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M23.066 7.636H.966V9.57h22.1zM23.066 14.182H.966v1.932h22.1z"
    }, null, -1)
  ]))]))
}
export default { render: render }